import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';
import { useCommentSlice } from '../CommentState';
import { ExtendedComment } from '../types';
import { generateTimestamp } from '../helper';

export const useMenuActionHandlers = () => {
  const loggedInUser = useSelector(selectUserProfile);
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  const [commentToDelete, setCommentToDelete] =
    useState<ExtendedComment | null>(null);

  // Handle delete confirmation
  const handleConfirmDelete = () => {
    if (commentToDelete) {
      dispatch(
        actions.deleteComment({
          commentId: commentToDelete.id,
          userId: loggedInUser.uid,
          commentSection: commentToDelete.section || 'Not Available',
          commentSectionCategory:
            commentToDelete.sectionCategory || 'Not Available'
        })
      );
    }
    setCommentToDelete(null);
  };

  // Handle delete cancellation
  const handleCancelDelete = () => {
    setCommentToDelete(null);
  };

  // Handle menu actions (Delete, Resolve, etc.)
  const handleMenuAction = (action: string, comment: ExtendedComment) => {
    switch (action) {
      case 'delete':
        setCommentToDelete(comment);
        break;
      case 'resolve':
        dispatch(
          actions.markStatus({
            commentId: comment.id,
            status: 'RESOLVED',
            userId: loggedInUser.uid,
            timestamp: generateTimestamp()
          })
        );
        break;
      case 'unresolve':
        dispatch(
          actions.markStatus({
            commentId: comment.id,
            status: 'OPEN',
            userId: loggedInUser.uid,
            timestamp: generateTimestamp()
          })
        );
        break;
      default:
        alert(`Custom action "${action}" performed on comment ${comment.id}`);
    }
  };

  return {
    handleMenuAction,
    deleteDialog: {
      isOpen: commentToDelete !== null,
      onConfirm: handleConfirmDelete,
      onCancel: handleCancelDelete
    }
  };
};
